import {useMatchMedia} from '@pexip/hooks';

import {MOBILE_DEVICE_PORTRAIT} from '../../constants/mediaQueries';

export const useMobileDevicePortrait = () =>
    useMatchMedia(MOBILE_DEVICE_PORTRAIT);
